module.exports = __webpack_public_path__ + "static/media/picture5.141deb84.png";